<template>
  <div class="page-content">

    <CustomerDashboard v-if="$hasRole('Customer')"></CustomerDashboard>
    <EngineerDashboard v-else-if="$hasRole('Engineer')"></EngineerDashboard>
    <Staff v-else></Staff>

  </div>
</template>

<script>
import Staff from './Staff.vue'
import EngineerDashboard from './Engineer.vue'
import CustomerDashboard from './Customer.vue'
export default {
  name: "Dashboard",
  components: {
    Staff,
    CustomerDashboard,
    EngineerDashboard
  },
  mounted(){
    console.log(this.$store.state.auth);
  }
}
</script>

